import { render, staticRenderFns } from "./SurfacePostModeration.vue?vue&type=template&id=262f679f&"
import script from "./SurfacePostModeration.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostModeration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports